import { useMemo, type FC } from 'react';
import { ListView, type ListViewItem } from '../../plugin-list-view';
import { useChatTranslation } from '../hooks/use-i18n';
import { Share, type ShareProps } from './share';
import { useOpenModal } from '../../next-modal';
import { modalId } from '../hooks/utils';
import { isMobile } from 'react-device-detect';
import { useConversationContext } from '../hooks/context';

export const ShareList: FC<ShareProps> = (props) => {
  const openModal = useOpenModal();
  const { t } = useChatTranslation();
  const { openAICoverToShare } = useConversationContext();
  const items: ListViewItem[] = useMemo(() => {
    return [
      {
        key: '0',
        title: t('text_to_share'),
        onClick: () => {
          openModal.modal({
            modalId,
            className: 'overflow-hidden',
            center: !isMobile,
            content: () => <Share {...props} />,
          });
        },
      },
      {
        key: '1',
        title: t('ai_cover_to_share'),
        onClick: () => {
          openAICoverToShare?.(props.chatId);
        },
      },
    ];
  }, [openAICoverToShare, openModal, props, t]);
  return <ListView items={items} />;
};
